import { h, VNode } from 'preact';
import { ClubEventItem, UserInput } from '../types';
import { Dispatch, StateUpdater } from 'preact/hooks';

interface GuestlistFormProps {
  userInput: UserInput;
  selectedEventItem: ClubEventItem | null;
  showNameError: boolean;
  onUpdateUserInput: Dispatch<StateUpdater<UserInput>>;
}

export function GuestlistForm({
  userInput,
  selectedEventItem,
  showNameError,
  onUpdateUserInput,
}: GuestlistFormProps): VNode {
  return (
    <div style={{ width: '100%' }}>
      <div className="label">
        Write your name + friends
      </div>
      <div className="guestlist-row">
        <input
          type="text"
          className="coloredInputDark"
          style={{ width: '70%' }}
          value={userInput.name}
          onChange={e =>
            onUpdateUserInput(prev => ({
              ...prev,
              name: (
                e.target as HTMLInputElement
              ).value.trim(),
            }))
          }
        />

        <select
          className="coloredInputLight"
          style={{ width: '20%' }}
          onChange={e =>
            onUpdateUserInput(prev => ({
              ...prev,
              plusOnes: +(e.target as HTMLOptionElement)
                .value,
            }))
          }>
          <option value={0} selected>
            +0
          </option>
          {selectedEventItem?.bookablePerGuest != null &&
          selectedEventItem.bookablePerGuest < 10
            ? Array.from(
                {
                  length:
                    selectedEventItem.bookablePerGuest,
                },
                (_, i) => i + 1,
              ).map(value => (
                <option key={value} value={value}>
                  +{value}
                </option>
              ))
            : Array.from(
                { length: 10 },
                (_, i) => i + 1,
              ).map(value => (
                <option key={value} value={value}>
                  +{value}
                </option>
              ))}
        </select>
      </div>

      {showNameError && (
        <div className="info" id="errorText">
          Please enter a first and last name
        </div>
      )}
    </div>
  );
}
